


import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

import { Header } from '../../Components/Layout/Header.jsx'
import { GameDetails } from '../../Components/Game/GameDetails.jsx'
import { ObavijestiCasino } from '../../Components/Layout/ObavijestiCasino.jsx'
import { Game } from '../../Components/Game/Game.jsx'

import { Banners } from '../../Components/Banner/Banners.jsx'
import { MojCasino } from '../../Components/Casino/MojCasino.jsx'
import { BonusItem } from '../../Components/Bonuses/BonusItem.jsx'
import { MaratonPobjednici } from '../../Components/Casino/MaratonPobjednici.jsx'


import { MaratonHappyHour } from '../../Components/Casino/MaratonHappyHour.jsx'
import { MaratonHappyHourPobjednici } from '../../Components/Casino/MaratonHappyHourPobjednici.jsx'

import { MetaTags } from '../../Components/Layout/MetaTags.jsx'



export class BonusesHappyHour extends React.Component {
    constructor(props) {
        super(props);
        casino.utils.createPageGoogleTagManagerEvent('Bonusi', 'Happy Hour', 'casino', this.props.user);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.showMenuFn(false);
    }

    render() {
        return <div>
            <MetaTags title="Bonusi - SuperSport CASINO" description="Game race bonusi u SuperSport CASINU!" />
            <Header key="header" {...this.state} {...this.props}></Header>
            <div className='white-background'>
                <div className="banner ">
                    <section className="happyhour  happyhour2 banner--inner selected">
                        <div className="banner--content">
                            <div className="banner--bg-container">
                                <div className="banner--repeater" />
                                <div className="banner--repeater2">
                                </div>
                                <div className="banner--background" />
                            </div>
                            <div className="banner--foreground">
                                <div className="banner--image">
                                </div>

                                <div className="banner--text">
                                    {/* <div className="as-inline-block center-verticaly">
                                            <span className="as-block text-white text-large text-xbold text-shadow">BUDI SPREMAN!</span>
                                        </div> */}
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <div id="page-wrapper" className="max-width-70 margin-center no-padding-on-mobile" >
                    <div style={{ height: '62px', display: 'block' }} className='mobile-hidden'></div>
                    <div className="padding-sides-medium-2 border-top-small white-background">
                        {/* <h2 className='v4 margin-bottom-small'>Uskrsni bonus maraton</h2> */}

                        <div style={{ fontWeight: 'bold', color: '#4a5863' }}>
                            Svakog dana, jednom ili više puta dnevno radimo malu utrku u trajanju jednog sata.
                            Kvalificiraj se u prvoj polovici sata i zavrti sretni spin u drugoj polovici te odnesi nagradu.
                            </div>
                        {/* <div style={{ fontWeight: 'bold', color: '#4a5863' }}>
                            U petak 24.12., subotu 25.12. i nedjelju 26.12. posebno Božićno izdanje  Happy Hour-a<br />
                            Happy Hour svaki sat!
                            </div> */}



                        <h2 className='v4 margin-bottom-small margin-top'>Kako do Happy Hour utrke?</h2>
                        <div className="content-container-hh">

                            <div className="column">
                                <img src="content/images/assets/ic_how_to_1@2x.png" />
                                <h3>Prati naš sretan sat</h3>
                                <p>
                                    Svakog dana, jednom ili više puta dnevno u trajanju od jednog sata možeš osvojiti vrlo zanimljivu nagradu! Prati naš "Happy Hour"!
                                </p>
                            </div>
                            <div className="column">
                                <img src="content/images/assets/ic_how_to_2@2x.png" />
                                <h3>Kvalificiraj se!</h3>
                                <p>
                                    Da bi se kvalificirao za izvlačenje, u prvoj polovici sretnog sata odigraj barem 20 vrtnji s ulogom od minimalno {casino.utils.switchKnToEur(1)} {casino.utils.switchCurrencyKnToEur()}. Samo tako možeš biti dobitnik bonusa.
                                </p>
                            </div>
                            <div className="column">
                                <img src="content/images/assets/ic_how_to_3@2x.png" />
                                <h3>Odigraj sretan spin!</h3>
                                <p>
                                    Izvlačenje dobitnika događa se u drugoj polovici sata. Tko od kvalificiranih igrača odigra sretni spin, dobiva poseban bonus.
                                </p>
                            </div>


                        </div>



                    </div>

                    <MaratonHappyHour {...this.props} hideHeader={true} extraClass="maraton2 white-background" />

                    <div className="padding-sides-medium-2 border-top-small white-background">
                        <h2 className='v4 margin-bottom-small margin-top'>Posljednji dobitnici</h2>
                    </div>


                    <MaratonHappyHourPobjednici showLoadingFn={this.props.showLoadingFn} />



                    <div className="text-center">

                        <a className="btn medium fill gray blue margin-top margin-bottom no-text-transform" target="_blank" href={`${casino.config.casinoCDNDocumentsUrl}/Pravila/HappyHour2020.pdf?c=${casino.config.guiCacheVerzija}`}>
                            <span >Pravila igre</span> <span className="icon ico-expand-outline"></span>
                        </a>
                    </div>


                </div>
            </div>
            <GameDetails  {...this.props} {...this.state} routePrefix="/promotions"></GameDetails>
            <ObavijestiCasino {...this.props}></ObavijestiCasino>
        </div>


    }
};
